






























import { Component, Prop, Vue } from 'vue-property-decorator'

import InfiniteLoading, { StateChanger } from 'vue-infinite-loading'

@Component({
  components: {
    InfiniteLoading
  }
})
export default class InfiniteScroll extends Vue {
  @Prop({ type: Boolean, required: true })
  didLoadAll!: boolean

  @Prop({ type: Function, required: true })
  handler!: () => Promise<boolean>

  @Prop({ type: Number })
  identifier?: number

  async loadMore ($state: StateChanger) {
    if (this.didLoadAll) {
      $state.loaded()
      $state.complete()
      return
    }

    try {
      const loaded = await this.handler()

      if (loaded) {
        $state.loaded()
      }

      if (this.didLoadAll) {
        $state.complete()
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)

      $state.error()
    }
  }
}
